import React, {Component} from "react";
import {Button, Checkbox, Form, Icon, Input, message,Modal} from "antd";
import CircularProgress from "../../components/CircularProgress/index";
import {
  userChangePassword,
  hideMessage,
  showAuthLoader,
  otpVerified,
  otpResend,
  forgetPasswordEmail,
} from "../../appRedux/actions/Auth";
import {connect} from "react-redux";
import IntlMessages from "util/IntlMessages";
import {Link} from "react-router-dom";

const FormItem = Form.Item;


class OTP extends Component {

  state = {
    confirmDirty: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.showAuthLoader();
        console.log(values)
        localStorage.setItem('emailForForgetPassword', values.email)
        var emailForOtp = localStorage.getItem('emailForForgetPassword');
        this.props.forgetPasswordEmail(emailForOtp,this.props.history)
       }
    });

  };

  info= () =>{
    Modal.info({
      title: 'OTP Resent',
      content: (
        <div>
          <p>We have Resent OTP on {localStorage.getItem('emailForSignUp')}</p>
        </div>
      ),
      onOk() {},
    });
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
        this.props.form.resetFields();
      }, 100);
    }
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({confirmDirty: this.state.confirmDirty || !!value});
  }

  render() {

    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div className="gx-login-container">
        <div className="gx-login-content">
          <div className="gx-login-header gx-text-center">
            <h1 className="gx-login-title gx-text-primary gx-font-weight-bold">Reset Password</h1>
          </div>
          <center><h4>Please enter your registered email address!</h4></center>


          <Form onSubmit={this.handleSubmit} className="gx-login-form gx-form-row0">
            <FormItem>
              {getFieldDecorator('email', {
                rules: [{
                  required: true, type: 'email', message: 'The input is not valid E-mail!',
                }],
              })(
                <Input name="email" placeholder="Email"/>
              )}
            </FormItem>
            {showMessage ?
              message.info(alertMessage.toString()) : null}
            <FormItem className="gx-text-center">
              <Button loading={loader} type="primary" className="gx-mb-0" htmlType="submit">Get Verification Code</Button>
            </FormItem>



          </Form>
        </div>
      </div>
    );
  }
}
const WrappedNormalOTPForm = Form.create()(OTP);

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};
export default connect(mapStateToProps, {
  hideMessage,
  showAuthLoader,
  otpVerified,
  otpResend,
  forgetPasswordEmail
})(WrappedNormalOTPForm);
